<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <em class="weui-form-preview__value">{{initData.ve_name}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.vd_biz_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应付日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.vd_pay_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <span class="weui-form-preview__value">{{initData.vd_biz_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{initData.vd_biz_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">凭证号</label>
            <span class="weui-form-preview__value">{{initData.vb_vocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{initData.vd_buyer}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.vd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">增加应付款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vd_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">增加预付款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vd_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应付总款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vd_end}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>